<h2 mat-dialog-title>Remove account</h2>
<mat-dialog-content class="mat-typography">
  <p>Are you sure you want to remove the account?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>